import { render, staticRenderFns } from "./ConfigurarPantallaServipag.vue?vue&type=template&id=4c6902c0&"
import script from "./ConfigurarPantallaServipag.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarPantallaServipag.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarPantallaServipag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports